import React, { useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import MyAppText from '../MyAppText';
import { translate } from '../../services/translate';
import { faCalendarCheck, faLocationDot, faPlay, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import OccurrenceVideoModal from '../dispatch/occurrenceForm/OccurrenceVideoModal';
import { appAgentService } from '../../services/central-api/app-agent';
import { WindowInformation } from '../../services/window-information';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import Card from '../Card';

export function SceneChangedOccurrence({ occurrence, navigation }: { occurrence: Occurrence; navigation: Navigation; }) {
    const { styles, theme } = useStyles(styleSheet);
    const [isModalVisible, setModalVisible] = useState(false);
    const windowInfo = WindowInformation();

    if (occurrence.triggerType !== 'scenechangedetection' && occurrence.triggerType !== 'defocus') {
        return <></>;
    }

    return (
        <View style={{ gap: 20 }}>
            <View style={{ gap: 5 }}>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <TouchableOpacity
                            onPress={() => {
                                window.open(`/dispatch/occurrences/detail/${occurrence?.id}`);
                            }}
                            disabled={windowInfo.isMobile}
                        >
                            <MyAppText style={{ fontSize: 16, color: theme.colors.labelColor, fontWeight: 'bold' }}>
                                {translate('nProtocol')}: {occurrence?.id}
                            </MyAppText>
                        </TouchableOpacity>
                        <MyAppText> </MyAppText>
                        <MyAppText style={{ fontSize: 14, color: theme.colors.card.detailText }}>
                            ({translate('team')} {translate(occurrence.OccurrenceUnits?.length && occurrence.OccurrenceUnits[0].OccurrenceUnit.isStarter ? 'starter' : 'support').toLowerCase()})
                        </MyAppText>
                    </View>
                    <TouchableOpacity onPress={() => navigation.navigate('AppAgent', { screen: 'AgentOccurrences' })}>
                        <FontAwesomeIcon color={theme.colors.textColor} fontSize={30} icon={faTimes} />
                    </TouchableOpacity>
                </View>
                <MyAppText style={styles.alertName}>{occurrence.resume.serialNo}</MyAppText>
                <MyAppText style={styles.alertText}>
                    {translate('cameraDepredationSuspect')}:
                </MyAppText>
            </View>
            <Card>
                <View>
                    <View style={styles.visualizedRow} >
                        <FontAwesomeIcon icon={faPlay} style={{ width: 22 }} color={theme.colors.iconColor} />
                        <TouchableOpacity onPress={() => setModalVisible(true)}>
                            <MyAppText style={styles.watchVideoText}>
                                {translate('watchVideo')}
                            </MyAppText>
                        </TouchableOpacity>
                    </View>
                    <View style={{ gap: 5 }}>
                        <MyAppText style={styles.cardBoldText}>{translate('occurredOn')}</MyAppText>
                        <View style={{ flexDirection: 'row', columnGap: 5 }}>
                            <FontAwesomeIcon icon={faLocationDot} style={{ color: theme.colors.iconColor }} />
                            <MyAppText style={styles.cardText}>{occurrence.externalReference?.title}</MyAppText>
                        </View>
                        <View style={{ flexDirection: 'row', columnGap: 5 }}>
                            <FontAwesomeIcon icon={faCalendarCheck} style={{ color: theme.colors.iconColor }} />
                            <MyAppText style={styles.cardText}>{moment(occurrence.resume.time).format('DD/MM/YYYY HH:mm:ss')}</MyAppText>
                        </View>
                    </View>
                </View>
                <View>
                    <View style={styles.visualizedRow}>
                        <MyAppText style={styles.cardBoldText}>{translate('occurrenceId')}:</MyAppText>
                        <MyAppText style={styles.cardText}>{occurrence.id}</MyAppText>
                    </View>
                    <View style={styles.visualizedRow}>
                        <MyAppText style={styles.cardBoldText}>{translate('priority')}:</MyAppText>
                        <MyAppText style={[styles.cardText, occurrence.priority === 'maximum' ? { color: '#FF0027' } : undefined]}>{occurrence.priority ? translate(occurrence.priority) : ''}</MyAppText>
                    </View>
                    <View>
                        <View style={{ paddingBottom: 30 }}>
                            <MyAppText style={styles.cardBoldText}>{translate('narrative')}:</MyAppText>
                            <MyAppText style={styles.cardText}>{occurrence.narrative}</MyAppText>
                        </View>
                    </View>
                </View>
            </Card>
            <OccurrenceVideoModal
                occurrenceId={occurrence.id || 0}
                isModalVisible={isModalVisible}
                setModalVisible={setModalVisible}
                occurrenceTime={new Date(occurrence.resume.time).getTime()}
                apiService={appAgentService}
            />
        </View>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    alertText: {
        color: theme.colors.labelColor,
        fontSize: 16,
        fontWeight: 'bold',
    },
    alertName: {
        color: theme.colors.textColor,
        fontSize: 18,
        fontWeight: 'bold',
        paddingBottom: 8
    },
    visualizedRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5
    },
    cardText: {
        color: theme.colors.iconColor,
        fontSize: 12
    },
    cardBoldText: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 14
    },
    plateInfoText: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 24
    },
    watchVideoText: {
        color: theme.colors.iconColor,
        fontSize: 16,
        textDecorationLine: 'underline'
    }
}));
